<template>
	<div class="relative">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
			<v-row
				v-if="$route.name === 'custom-statement'"
				class="ma-0"
				style="width: 100%"
				align="center"
				justify="start"
			>
				<v-col cols="auto" class="d-flex flex-column justify-start">
					<slot name="breadcrumbs" :item="true"></slot>
				</v-col>
				<v-spacer></v-spacer>
				<!-- export -->
				<v-col cols="auto" class="text-sm-start text-center">
					<v-menu offset-y>
						<template v-slot:activator="{ on }">
							<v-btn dark color="printingColor" class="px-2" v-on="on">
								<span class="d-flex align-center">
									<v-icon color="white">mdi-export-variant</v-icon>
									<span style="font-size: 14px">
										{{$t('AccountCustomStatementPage.export')}}
									</span>
								</span>
							</v-btn>
						</template>

						<bee-list>
							<!-- excel -->
							<bee-list-item
								context="custom_statement"
								:item="exportItems[0]"
								dense
								@click="exportAs('excel')"
							></bee-list-item>

							<!-- pdf -->
							<bee-list-item
								context="custom_statement"
								:item="exportItems[1]"
								dense
								@click="exportAs('pdf')"
							></bee-list-item>
				
						</bee-list>
					</v-menu>
				</v-col>
			</v-row>
			<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
				<!-- custom statement -->
				<v-col cols="auto" lg="3" class="d-flex flex-column">
					<bee-autocomplete
						v-model="custom_statement_id"
						:label="$t('AccountCustomStatementPage.custom-statements')"
						:items="!isStatisticsView ? custom_statements : customStatements"
						item-text="name"
						item-value="id"
						ref="BeeAutocomplete"
						:hide-details="true"
						@keydown-enter-prevent="search()"
						context="custom_statement"
						:action-name="actions.GET"
					></bee-autocomplete>
				</v-col>

				<v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="d-flex flex-column">
					<bee-checkbox
						v-model="show_non_zero_accounts_only"
						:label="$t('AccountCustomStatementPage.balanced-accounts-only')"
						class="small-font-size mt-0" 
					></bee-checkbox>
				</v-col>

				<!-- show all columns -->
				<v-col cols="auto" lg="auto" md="auto" sm="6" class="d-flex px-lg-0 flex-column">
					<bee-checkbox
						v-model="show_all_columns"
						:label="$t('AccountCustomStatementPage.show-all-columns')"
						class="small-font-size mt-0"
					></bee-checkbox>

				</v-col>
				<v-spacer v-if="!isStatisticsView"></v-spacer>
				<!-- search -->
				<v-col cols="auto" lg="auto" md="auto" sm="3" class="d-flex justify-end">
					<bee-btn  
						@click="search()"
						:content="$t('AccountCustomStatementPage.refresh')"
						color="blueGray"
						outer-class="mt-0 me-3"
						:loading="loading"
						context="custom_statement" 
						:action-name="actions.GET"
					></bee-btn>
					<v-icon small color="grey" @click="reset()" :loading="loading">fa-times-circle</v-icon>
				</v-col>
			</v-layout>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
			<v-card flat>
				<v-card-text class="pt-0 px-3">
					<!-- main table -->
					<bee-simple-table
						:fixed-header="true"
						:with-color="false"
						:zebra="true"
						:clickable="true"
						:hide-footer="true"
						empty-state="dashes"
						:headers="showHeaders"
						:items="!isStatisticsView ? custom_statement_rows : customStatementsData.custom_statement_rows"
						:configs="!isStatisticsView ? configs : { accounts }"
						@dblclick:row="(e, i) => $router.push({name: 'statement', params:{id: i.item.account_id}})"
					></bee-simple-table>
					
					<!-- summery table -->
					<bee-simple-table
						v-if="0"
						class="pt-5"
						:with-color="true"
						:zebra="false"
						empty-state="none"
						:hide-footer="true"
						:configs="configs"
						:headers="sum_debit_credit_result_headers"
						:items="custom_statement_summary"
						@equivalent-currency-id-changed="changeSumDifferenceEquivalent($event)"
					></bee-simple-table>
				</v-card-text>
			</v-card>
		</div>

		<!-- footer -->
		<v-bottom-navigation id="footer" app horizontal class="px-3" background-color="#E1E2E4">
			<v-row align="center" justify="center" class="flex-wrap">
				<v-spacer></v-spacer>
				<!-- debit balance -->
				<v-col cols="auto" lg="auto" class="d-flex flex-column">
					<bee-outlined-header-info
					    border-color="transparent"
					    :head="$t('AccountCustomStatementPage.total-debit-balance')"
					>
						<template v-slot:content="{}">
							<bee-advanced-money-label
								empty-state="_"
								v-model="debit_balance"
								:bold="true"
								:with-color="true"
								:currencies="currencies"
							></bee-advanced-money-label>
						</template>
					</bee-outlined-header-info>
				</v-col>

				<!-- credit balance -->
				<v-col cols="auto" lg="auto" class="d-flex flex-column">
					<bee-outlined-header-info
					    border-color="transparent"
						:head="$t('AccountCustomStatementPage.total-credit-balance')"
					>
						<template v-slot:content="{}">
							<bee-advanced-money-label
								empty-state="_"
								v-model="credit_balance"
								:bold="true"
								:with-color="true"
								:currencies="currencies"
							></bee-advanced-money-label>
						</template>
					</bee-outlined-header-info>
				</v-col>
			</v-row>
		</v-bottom-navigation>
	</div>
</template>
<script>
import store from "../../../store/index.js";
import { mapGetters, mapState } from "vuex";
import actions from "../../../permissions/actions-names.js";
import ls from "../../../settings/localStorageExtension";

export default {
	data: () => ({
		actions,
		custom_statement_id: null,
		show_all_columns: false,
		show_non_zero_accounts_only: false,
		obj: {},
		loading: false,

		customStatements: [],
		customStatementsData: {}
	}),

	watch: {
		'$route.query.financialFileId': {
			handler() {
				if (this.isStatisticsView && this.$route.query.financialFileId) {
					this.$store.dispatch('accounts/fetchAll', {
						financialFileId: this.$route.query.financialFileId,
					});
					this.$store.dispatch('customStatements/fetchAll', {
						financialFileId: this.$route.query.financialFileId
					}).then(data => {
						this.customStatements = data;
					});
				}
			},
			immediate: true
		},
	},

	computed: {
		exportItems() {
			return [
				{
					text: this.$t('AccountCustomStatementPage.export-as-excel'),
					icon: 'mdi-microsoft-excel',
					context: 'custom_statement',
					action_name: actions.EXPORT_AS_PDF
				},
				{
					text: this.$t('AccountCustomStatementPage.print-the-account-custom-statement'),
					icon: 'mdi-printer',
					context: 'custom_statement',
					action_name: actions.EXPORT_AS_PDF
				},
			]
		},

		// tables headers
		headers() {
			return [
				{
					text: this.$t('AccountCustomStatementPage.headers.account-no'),
					value: " account_id",
					type: "accounts-autocomplete",
					width: "10%",
					settings: { itemText: "accounting_no" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.account-name'),
					value: "account_id",
					type: "accounts-autocomplete",
					width: "10%",
					settings: { itemText: "name" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.parent-account'),
					value: "parent_account_id",
					type: "accounts-autocomplete",
					width: "10%",
					settings: { itemText: "name" }
				},
				// {text: 'مجموع المدين', value: 'debit_sum', type: 'money', width: '10%'},
				// {text: 'مجموع الدائن', value: 'credit_sum', type: 'money', width: '10%'},
				{
					text: this.$t('AccountCustomStatementPage.headers.debit-balance'),
					value: "debit_balance",
					type: "money",
					width: "15%",
					settings: { emptyState: "none" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.credit-balance'),
					value: "credit_balance",
					type: "money",
					width: "15%",
					settings: { emptyState: "none" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.last-debit-amount'),
					value: "last_debit_amount",
					type: "money",
					width: "10%",
					settings: { emptyState: "none" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.last-debit-date'),
					value: "last_debit_date",
					type: "date",
					width: "10%"
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.last-credit-amount'),
					value: "last_credit_amount",
					type: "money",
					width: "10%",
					settings: { emptyState: "none" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.last-credit-date'),
					value: "last_credit_date",
					type: "date",
					width: "10%"
				}
			]
		},

		subHeaders() {
			return [
				{
					text: this.$t('AccountCustomStatementPage.headers.account-no'),
					value: " account_id",
					type: "accounts-autocomplete",
					width: "10%",
					settings: { itemText: "accounting_no" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.account-name'),
					value: "account_id",
					type: "accounts-autocomplete",
					width: "22%",
					settings: { itemText: "name" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.parent-account'),
					value: "parent_account_id",
					type: "accounts-autocomplete",
					width: "22%",
					settings: { itemText: "name" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.debit-balance'),
					value: "debit_balance",
					type: "money",
					width: "23%",
					settings: { emptyState: "none" }
				},
				{
					text: this.$t('AccountCustomStatementPage.headers.credit-balance'),
					value: "credit_balance",
					type: "money",
					width: "23%",
					settings: { emptyState: "none" }
				}
			]
		},

		sum_debit_credit_result_headers(){
			return [
				{ text: "", value: "1", type: "", width: "20%" },
				{
					text: this.$t('AccountCustomStatementPage.sum-debit-credit-result-headers.sum-debits'),
					value: "sum_debits",
					type: "money",
					width: "10%",
					settings: { perspective: "statement" }
				},
				{
					text: this.$t('AccountCustomStatementPage.sum-debit-credit-result-headers.sum-credits'),
					value: "sum_credits",
					type: "money",
					width: "10%",
					editable: true,
					settings: { perspective: "statement" }
				},
				{
					text: this.$t('AccountCustomStatementPage.sum-debit-credit-result-headers.debit-balance'),
					value: "debit_balance",
					type: "money",
					width: "10%",
					settings: { perspective: "statement" }
				},
				{
					text: this.$t('AccountCustomStatementPage.sum-debit-credit-result-headers.credit-balance'),
					value: "credit_balance",
					type: "money",
					width: "10%",
					editable: true,
					settings: { perspective: "statement" }
				},
				{ text: "", value: "", type: "", width: "40%" }
			]
		},

		custom_statement_rows() {
			return this.account_custom_statement?.custom_statement_rows;
		},
		custom_statement_summary() {
			const data = !this.isStatisticsView ? this.account_custom_statement : this.customStatementsData;
			return data?.custom_statement_summary ? [].concat(data.custom_statement_summary) : [];
		},

		file_is_locked() {
			return this.configs?.financial_file?.is_locked;
		},

		showHeaders() {
			return this.show_all_columns ? this.headers : this.subHeaders;
		},

		currencies() {
			return !this.isStatisticsView
				? this.configs.currencies
				: this.allCurrencies.map(c => ({
					...c,
					is_main_currency:
						c.id === this.getFinancialFileById(+this.$route.query.financialFileId).default_currency_id
				}))
		},

		// footer
		debit_balance(){
			return this.custom_statement_summary[0]?.debit_balance;
		},
		credit_balance(){
			return this.custom_statement_summary[0]?.credit_balance;
		},
		...mapState({
			configs: state => state.configs.configs,
			account_custom_statement: state => state.statements.account_custom_statement,
			custom_statements: state => state.customStatements.custom_statements,
			accounts: state => state.accounts.accounts,
			allCurrencies: state => state.currencies.currencies,
		}),

		...mapGetters({
			getFinancialFileById: 'financialFiles/getFinancialFileById'
		}),

		isStatisticsView() {
			return this.$route.name.includes('statistics');
		}
	},

	methods: {
		changeSumDifferenceEquivalent(toCurrencyId) {
			if (toCurrencyId) {
				let sum_difference = this.account_custom_statement
					.custom_statement_summary.sum_difference;
				if (sum_difference?.amount) {
					let amount = sum_difference.amount;
					let fromCurrecyId = sum_difference.currency_id;
					store
						.dispatch("currencies/exchangeToCurrency", {
							toCurrencyId,
							amount,
							fromCurrecyId
						})
						.then(response => {
							_.set(
								this.account_custom_statement.custom_statement_summary
									.sum_difference_equivalent,
								"amount",
								response.amount
							);
							_.set(
								this.account_custom_statement.custom_statement_summary
									.sum_difference_equivalent,
								"currency_id",
								response.currency_id
							);
						});
				}
			}
		},
		search(){
			if (this.custom_statement_id) {
				let promise;
				if (!this.isStatisticsView) {
					promise = this.$store.dispatch("statements/fetchAccountCustomStatement", {
						custom_statement_id: this.custom_statement_id,
						show_non_zero_accounts_only : this.show_non_zero_accounts_only
					}).then(() => {
						this.$router.push({
							name: "custom-statement",
							params: { id: this.custom_statement_id }
						}).catch(() => {});
					})
				} else {
					promise = this.$store.dispatch('statistics/fetchAccountCustomStatement', {
						customStatementId: this.custom_statement_id,
						financialFileId: this.$route.query.financialFileId,
						userId: ls.getLocalUser()?.id
					}).then(data => {
						this.customStatementsData = data;
					});
				}
				
				this.loading = true;
				promise.finally(() => {
					this.loading = false;
				})
			}
		},
		exportAs(type) {
			this.$store.dispatch('reports/CustomAccountStatement', {
				type,
				financialFileId: this.configs.financial_file.id,
				customStatementId: this.custom_statement_id,
				userId: ls.getLocalUser().id,
				showNonZeroAccountsOnly: this.show_non_zero_accounts_only
			})
		},
		reset() {
			if (this.isStatisticsView) {
				this.$router.push({ name: "account-custom-statement" })
					.then(() => store.dispatch("statements/clear"))
					.catch(() => {});
			}
			this.custom_statement_id = null;
			this.show_non_zero_accounts_only = null;

			this.setFocus();
		},
		setFocus() {
			this.$refs["BeeAutocomplete"].$refs.BeeAutocomplete.focus();
		}
	},

	mounted() {
		window.observer.observe(document.querySelector("#tool-bar"))
		window.observer.observe(document.querySelector("#footer"))
		
		if (this.$route.params.id && !this.isStatisticsView) {
			this.custom_statement_id = Number(this.$route.params.id);
			this.search()
		}

		if (this.isStatisticsView && !this.allCurrencies.length) {
			this.$store.dispatch('currencies/fetchAll')
		}

		this.setFocus();
	},

	async beforeRouteEnter(to, from, next) {
		next();
	}
};
</script>
<style scoped>
.small {
	max-width: 600px;
	margin: 150px auto;
}
.small-font-size .v-label {
	font-size: 0.8rem !important;
	padding-right: 0px !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>
